import { useMutation } from '@tanstack/react-query'

import type { ApiErrorResponse, UseAppMutationOptions } from '../../../../types'
import type { BulkCreateRestsListOptions } from '../rest.api'
import { bulkCreateRestsList } from '../rest.api'
import { restBulkCacheKeys } from '../rest.cacheKeys'

export const useBulkCreateRestsList = (
  mutationOpts?: UseAppMutationOptions<BulkCreateRestsListOptions>
) => {
  // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
  return useMutation<null, ApiErrorResponse, BulkCreateRestsListOptions>({
    ...mutationOpts,
    mutationKey: restBulkCacheKeys.createBulk(),
    mutationFn: (opts: BulkCreateRestsListOptions) => bulkCreateRestsList(opts)
  })
}
